module.exports = __webpack_public_path__ + "static/media/ninja-sitting.13f9b2fe.png";